import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Logger } from 'data/common';
import reducers from '../reducer';

let store = null;

if (!__DEV__) {
    store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)));
} else {
    try {
        const Reactotron = require('./ReactotronConfig');
        store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk), Reactotron.createEnhancer()));
    } catch (e) {
        Logger.error(e);
    }
}

export default store;



// WEBPACK FOOTER //
// ./store/index.js